import axios from 'axios';

/**
 * 获取阵列位移计推送设置
 */
export const getPushConfig = ({ projectId }) => {
  return axios.get('/api/data-push/push-config', { params: { projectId } });
};

/**
 * 更新阵列位移计推送设置
 */
export const updatePushConfig = (pushConfig) => {
  return axios.patch('/api/data-push/push-config', { ...pushConfig });
};

/**
 * 提交历史推送任务
 */
export const postHistoryPush = ({ startTime, endTime, projectId }) => {
  return axios.post('/api/data-push/history', { startTime, endTime, projectId });
};

/**
 * 查询推送记录
 */
export const getPushLogs = ({ projectId, deviceId }) => {
  return axios.get('/api/data-push/logs', { params: { projectId, deviceId } });
};
